import i18n from '../../locales/index'
import restful from '../vuex'

const state = {
  ...restful.states('breakage')
}

const getters = {
  ...restful.getters('breakage')
}

const actions = {
  ...restful.actions('breakages')
}

const mutations = {
  ...restful.mutations('breakage')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
